import { render, staticRenderFns } from "./EstablishmentEditTabSocial.vue?vue&type=template&id=40ddc1a6&"
import script from "./EstablishmentEditTabSocial.vue?vue&type=script&lang=js&"
export * from "./EstablishmentEditTabSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports